import React from "react";
import { Box } from "@mui/material";
import { useInViewOnce } from "./useInViewOnce";
import { usePrefersReducedMotion } from "./usePrefersReducedMotion";

/**
 * Subtle scroll reveal (fade-up or fade-in). Animates once; skipped when prefers-reduced-motion.
 */
const FadeInOnScroll = ({
  children,
  variant = "fade-up",
  delay = 0,
  sx = {},
  component = "div",
}) => {
  const prefersReducedMotion = usePrefersReducedMotion();
  const [ref, isInView] = useInViewOnce();
  const visible = prefersReducedMotion || isInView;

  const hiddenTransform =
    variant === "fade-in" ? "none" : "translate3d(0, 20px, 0)";

  return (
    <Box
      ref={ref}
      component={component}
      sx={{
        opacity: visible ? 1 : 0,
        transform: visible ? "none" : hiddenTransform,
        transition: prefersReducedMotion
          ? "none"
          : `opacity 0.65s ease-out ${delay}ms, transform 0.65s ease-out ${delay}ms`,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default FadeInOnScroll;
